import { render, staticRenderFns } from "./DragableCard.vue?vue&type=template&id=c7d2671e&scoped=true&"
import script from "./DragableCard.vue?vue&type=script&lang=ts&"
export * from "./DragableCard.vue?vue&type=script&lang=ts&"
import style0 from "./DragableCard.vue?vue&type=style&index=0&id=c7d2671e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7d2671e",
  null
  
)

export default component.exports